import { useEffect, useRef, useState } from "react";
import { userData } from "../../services/apiData";
import { SignatureIcons } from "../SignatureIcons";
import { ProfilePicture } from "../ProfilePicture";
import { UserDataV2 } from "../UserDataV2";
import { SignatureBanner } from "../SignatureBanner";
import { CopySignatureButton } from "../CopySignatureButton";
import { copySignatureContent } from "../../utils/copySignature";
import { StyledTr, StyledTable, UserDataTd, IconsTd, SignaturePreviewFrame } from "./SignatureCoreCard.styles";
import BannerTeltec from "assets/bannerTeltec.png";

export const SignatureCoreCard = ({ accessToken }: any) => {
  const initState = {
    givenName: "",
    jobTitle: "",
    displayName: "",
    surname: "",
    mobilePhone: "",
    businessPhones: 0,
    mail: "",
  };

  const [info, setInfos] = useState(initState);
  const [customPhone, setCustomPhone] = useState<string>("");
  const [selectedBanner, setSelectedBanner] = useState<string>(BannerTeltec);
  const [copyStatus, setCopyStatus] = useState<"idle" | "success" | "error">("idle");
  const [dataLoading, setDataLoading] = useState<boolean>(true);
  const signatureRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (accessToken) {
      userData(accessToken).then((res) => {
        const data = {
          givenName: res.givenName,
          jobTitle: res.jobTitle,
          displayName: `${res.givenName} ${res.surname}`,
          surname: res.surname,
          mobilePhone: res.mobilePhone,
          businessPhones: res.businessPhones[0],
          mail: res.mail,
        };
        setInfos(data);
        setDataLoading(false);
      });
    }
  }, [accessToken]);

  const handleCopySignature = async () => {
    if (!signatureRef.current) {
      return;
    }

    const copied = await copySignatureContent(signatureRef.current);
    setCopyStatus(copied ? "success" : "error");
    window.setTimeout(() => setCopyStatus("idle"), 2500);
  };

  return dataLoading === true ? (
    <p>loading...</p>
  ) : (
    <div>
      <CopySignatureButton onClick={handleCopySignature} status={copyStatus} />
      <SignaturePreviewFrame>
        <div ref={signatureRef}>
          <StyledTable>
            <tbody>
              <StyledTr>
                <td>
                  <ProfilePicture info={info} accessToken={accessToken} />
                </td>
                <UserDataTd>
                  <UserDataV2
                    givenName={info.givenName}
                    surname={info.surname}
                    jobTitle={info.jobTitle}
                    phone={customPhone === "" ? info.businessPhones : customPhone}
                  />
                </UserDataTd>
                <IconsTd>
                  <SignatureIcons />
                </IconsTd>
              </StyledTr>
            </tbody>
          </StyledTable>
          <SignatureBanner
            banner={selectedBanner}
            setBanner={setSelectedBanner}
            customPhone={customPhone}
            setCustomPhone={setCustomPhone}
            showControls={false}
          />
        </div>
      </SignaturePreviewFrame>
      <SignatureBanner
        banner={selectedBanner}
        setBanner={setSelectedBanner}
        customPhone={customPhone}
        setCustomPhone={setCustomPhone}
        showBanner={false}
      />
    </div>
  );
};
